export const optionConstants = {
    IDEA: 'idea',
    QUALIFICATION: 'qualification',
    PROFILE: 'edit-profile',
    NOTIFICATIONS: 'notifications',
    TUTORIAIS: 'tutoriais',
    ADMINISTRADORES: 'administradores',
    PRIMEIROACESSO: 'primeiro-acesso',
    FAQ: 'faq'
};
  